import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import { toast } from "react-toastify";

if (sessionStorage.getItem("authToken")) {
    axios.defaults.headers.common['Auth-Token'] = sessionStorage.getItem("authToken");
}

export const types = {
    INIT: 'ARTICLE/INIT',
    FETCH_ARTICLES: 'ARTICLE/FETCH_ARTICLES',
    FETCH_ARTICLES_SUCCESS: 'ARTICLE/FETCH_ARTICLES_SUCCESS',
    UPDATE_QUERY: 'ARTICLE/UPDATE_QUERY',
    CHANGE_PAGE: 'ARTICLE/CHANGE_PAGE',
    SET_PAGE_SIZE: 'ARTICLE/SET_PAGE_SIZE',
    UPDATE_SORT_PROPERTIES: 'ARTICLE/UPDATE_SORT_PROPERTIES',
};

export const initialState = fromJS({
    articles: [],
    query: '',
    sortProperties: {
        propertyToSortBy: 'gtin',
        sortDirection: 'asc'
    },
    pagination: {
        page: 0,
        pageSize: 25,
        totalPages: 0,
        totalElements: 0
    },
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_ARTICLES_SUCCESS:
            return state
            .set('articles', fromJS(action.articles))
            .setIn(['pagination', 'totalPages'], fromJS(action.totalPages))
            .setIn(['pagination', 'totalElements'], fromJS(action.totalElements));
        case types.SET_PAGE_SIZE:
            return state.setIn(['pagination', 'pageSize'], fromJS(action.pageSize))
            .setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_QUERY:
            return state.set('query', fromJS(action.query)).setIn(['pagination', 'page'], fromJS(0));
        case types.CHANGE_PAGE:
            return state.setIn(['pagination', 'page'], fromJS(action.page));
        case types.UPDATE_SORT_PROPERTIES:
            return state
            .setIn(['sortProperties', 'propertyToSortBy'], fromJS(action.propertyToSortBy))
            .setIn(['sortProperties', 'sortDirection'], fromJS(action.sortDirection));
        default:
            return state
    }
};

export const initialise = () => {
    return (dispatch) => {
        dispatch(fetchArticles());
    };

};

export const fetchArticles = () => {
    return function (dispatch, getState) {
        const {query, pagination, sortProperties} = getState().article.toJS();

        const path = __API__ +
                `/api/ui/article?search=${query}&page=${pagination.page}&pageSize=${pagination.pageSize}&propertyToSortBy=${sortProperties.propertyToSortBy}&sortDirection=${sortProperties.sortDirection}`;

        return axios.get(path)
        .then(response => {
            return response.data;
        })
        .then(data => {
            dispatch(fetchArticlesSuccess(data.content, data.totalPages, data.totalElements));
        })
        .catch(error => {
            console.log(error)
        });
    }
};

export const fetchArticlesSuccess = (articles, totalPages, totalElements) => {
    return {
        type: types.FETCH_ARTICLES_SUCCESS,
        articles: articles,
        totalPages: totalPages,
        totalElements: totalElements
    };
};

export const updateQuery = (query) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_QUERY,
            query: query
        });
        dispatch(fetchArticles());
    }
};

export const updatePage = (newPage) => {
    return {
        type: types.CHANGE_PAGE,
        page: newPage
    };
};

export const changePage = (newPage) => {
    return function (dispatch) {
        dispatch(updatePage(newPage));
        dispatch(fetchArticles());
    }
};

export const setPageSize = (pageSize) => {
    return function (dispatch) {
        dispatch({
            type: types.SET_PAGE_SIZE,
            pageSize: pageSize
        });
        dispatch(fetchArticles());
    }
};

export const updateSortProperty = (propertyToSortBy) => {
    return function (dispatch, getState) {
        const {sortProperties} = getState().article.toJS();
        const asc = 'asc';
        const desc = 'desc';
        let sortDirection = 'asc';
        if (sortProperties.propertyToSortBy === propertyToSortBy) {
            sortDirection = sortProperties.sortDirection === asc ? desc : asc;
        }
        dispatch({
            type: types.UPDATE_SORT_PROPERTIES,
            propertyToSortBy: propertyToSortBy,
            sortDirection: sortDirection
        });
        dispatch(fetchArticles());
    }
};

export const updateGtin = (oldGtin, newGtin) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/article/gtin`;

        const command = {
            oldGtin: oldGtin,
            newGtin: newGtin
        };

        return axios.put(path, command)
        .then(response => {
            return response.data;
        })
        .then(() => {
            dispatch(fetchArticles());
            toast.success('Artikel-GTIN wurde geändert!');
        })
        .catch(error => {
            toast.error('Artikel-GTIN konnte nicht geändert werden!');
        });
    }
};

export const updateErpIdno = (gtin, erpIdno) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/article/erpidno`;

        const command = {
            gtin: gtin,
            erpIdno: erpIdno
        };

        return axios.put(path, command)
        .then(response => {
            return response.data;
        })
        .then(() => {
            dispatch(fetchArticles());
            toast.success('SAP-Nr. wurde geändert!');
        })
        .catch(error => {
            toast.error('AP-Nr. konnte nicht geändert werden!');
        });
    }
};

export const updateVendorArticleNumber = (gtin, vendorArticleNumber) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/article/vendorarticlenumber`;

        const command = {
            gtin: gtin,
            vendorArticleNumber: vendorArticleNumber
        };

        return axios.put(path, command)
        .then(response => {
            return response.data;
        })
        .then(() => {
            dispatch(fetchArticles());
            toast.success('Hersteller-Artikelnummer wurde geändert!');
        })
        .catch(error => {
            toast.error('Hersteller-Artikelnummer konnte nicht geändert werden!');
        });
    }
};

export const updateName = (gtin, name) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/article/name`;

        const command = {
            gtin: gtin,
            name: name
        };

        return axios.put(path, command)
        .then(response => {
            return response.data;
        })
        .then(() => {
            dispatch(fetchArticles());
            toast.success('Artikel-Name wurde geändert!');
        })
        .catch(error => {
            toast.error('Artikel-Name konnte nicht geändert werden!');
        });
    }
};

export const createNewArticle = (article) => {
    return function (dispatch, getState) {
        const path = __API__ + '/api/ui/article';

        const command = {
            name: article.name,
            gtin: article.gtin,
            brand: article.brand,
            erpIdno: article.erpIdno,
            vendorArticleNumber: article.vendorArticleNumber
        };

        return axios.post(path, command)
        .then(response => {
            return response.data;
        })
        .then(() => {
            dispatch(fetchArticles());
            toast.success('Artikel wurde angelegt!');
        })
        .catch(error => {
            toast.error('Artikel konnte nicht gespeichert werden!');
        });
    }
};



// WEBPACK FOOTER //
// ./src/admin/article/reducer.js